<template>
  <div>
    <div class="bossPic">
      <img src="https://souquan.wang/api/images/boss.jpg" class="code_pic" />
    </div>
    <div class="titleBox">
      和搜券王一起成长，分享搜券王的成果
    </div>
    <div class="ways">
      <div class="ways1"><span>联系/合作方式</span><span class="ways2">(长按复制)</span>:</div>
      <ul>
        <li class="ways_list">
          <img src="https://souquan.wang/api/images/weixin.png" class="icon_pic" /><span class="ways_name">amwuetk</span>
        </li>
        <li class="ways_list">
          <img src="https://souquan.wang/api/images/qq.png" class="icon_pic" /><span class="ways_name">613037200</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name:"bePromoter"
}
</script>

<style lang="stylus">
  .bossPic
    padding:30px
    background:#fff
    .code_pic
      width:200px
      height:200px
      display:block
      margin:0 auto
  .titleBox
    padding:0 30px 30px
    background:#fff
    font-size:30px
    color:#333
    text-align:center
  .ways
    background:#fff
    margin-top:20px
    padding:30px 0
    .ways1
      font-size:28px
      color:333
      margin-bottom:15px
      padding:0 30px
    .ways2
      font-size:24px
      color:#999
      margin:0 10px 0 5px
    .ways_list
      padding:15px;
      border-top:1px solid #f0f0f0
      /*px*/
      .icon_pic
        width:50px
        height:50px
        border-radius:50%
        vertical-align:middle
        margin-right:15px
      .ways_name
        font-size:30px
        color:#333
        vertical-align:middle


</style>



// WEBPACK FOOTER //
// src/components/userCenter/BePromoter.vue